import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EngagementsReject extends ApplicationRecord {
  static jsonapiType = "engagements/reject";

  @Attr() engagementId: number;

  @Attr() employerUserId: number;

  @Attr() rejectedMessage: string;
}

export default EngagementsReject;
